export default "__VITE_ASSET__ccYgZNrE__"